﻿//@ts-nocheck
export class MainNavigationHandler {
    public static MobileNavToggle($: JQueryStatic): void {
        $(".navRoot").addClass("open");

        $(".burger-menu__container").on("click", function () {
            $(".navRoot").addClass("open").removeClass("hidden");

            $(this).parent().find(".mainNav-widget").toggleClass("open");

            $("body").toggleClass("nav-open");

            if (!$("body").hasClass("nav-open")) {
                $(".navLevel-1, .navLevel-2").each(function () {
                    $(this).removeClass("hidden").removeClass("open");
                });
            }
        });
    }

    public static MobileNavFunctionality($: JQueryStatic): void {
        const backBtn = `<button class='nav-back-btn'>Back</button>`;

        $(".navLevel-1").prepend(backBtn);
        $(".navLevel-2").prepend(backBtn);

        $(".navList > li.hasChildren").on("click", function (e) {
            e.stopPropagation();

            $(this).closest(".navList").addClass("hidden").removeClass("open");

            $(this).find("> .navList").removeClass("hidden").addClass("open");
        });

        $(".nav-back-btn").on("click", function (e) {
            e.stopPropagation();

            if ($(this).parent(".navLevel-2").length) {
                $(this).parent().removeClass("open");
                $(this)
                    .closest(".navLevel-1")
                    .addClass("open")
                    .removeClass("hidden");
            } else if ($(this).parent().parent(".navLevel-1").length) {
                $(this).parent().parent().removeClass("open");
                $(".navRoot").addClass("open").removeClass("hidden");
            } else {
                $(this).parent().parent().removeClass("open");
                $(this)
                    .closest(".navLevel-1")
                    .addClass("open")
                    .removeClass("hidden");
                $(".navRoot").removeClass("open").addClass("hidden");
            }
        });
    }

    public static repositionNavBanners($: JQueryStatic): void {
        $(window).on("load", function () {
            $(".main-header__navigation .navRoot > li").each(function (
                idx,
                val
            ) {
                const banners = $(val).find(
                    "> .text-node > .nav-banner-container"
                );

                const detached = $(banners).detach();

                $(val).find("> .navLevel-1").prepend(detached);

                $(banners).css("display", "block");
            });
        });
    }

    public static wrapNavItems($: JQueryStatic): void {
        const wrapper = '<div class="inner-nav-wrapper" />';
        const linkWrapper = '<div class="links" />';

        $(".main-header .mainNav-widget .navRoot > li .navLevel-1").each(
            function (id, val) {
                $(val).find("> li").wrapAll(linkWrapper);
            }
        );

        $(".main-header .navLevel-1").each(function (idx, val) {
            $(val).find("> *").wrapAll(wrapper);
        });
    }

    public static DesktopMouseOnNav($: JQueryStatic): void {
        if ($(window).width() > 990) {
            $(".main-header .mainNav-widget .navRoot > li")
                .not(".search-overlay-trigger")
                .on("mouseenter", function () {
                    $("body").addClass("nav-open-desktop");
                    $(".main-header .navRoot > li").removeClass("is-active");
                    $(this).addClass("is-active");
                });

            $(".search-overlay-trigger").on("mouseenter", function () {
                $("body").removeClass("nav-open-desktop");
            });

            let isMouseOver = false;
            let MouseLeaveTimer = null;

            $(".main-header .navLevel-1, .main-header .navLevel-2").on(
                "mouseenter",
                function () {
                    isMouseOver = true;

                    window.clearTimeout(MouseLeaveTimer);

                    if ($("body").hasClass("nav-open-desktop")) {
                        return;
                    }

                    setTimeout(function () {
                        if (!isMouseOver) return;
                        $("body").addClass("nav-open-desktop");
                    }, 200);
                }
            );

            $(".main-header").on("mouseleave", function () {
                isMouseOver = false;

                MouseLeaveTimer = setTimeout(function () {
                    $("body").removeClass("nav-open-desktop");
                }, 200);
            });
        }
    }
}

export const navLevel1LiHoverHanderler = () => {
    const navLevel1Li = document.querySelectorAll(
        ".main-header__navigation .mainNav-widget .navLevel-1  li"
    );

    navLevel1Li.forEach((li) => {
        li.addEventListener("mouseenter", (e) => {
            navLevel1Li.forEach((li) => {
                li.classList.add("non-active");

                if (li.classList.contains("is-active")) {
                    li.classList.remove("is-active");
                }
            });

            li.classList.remove("non-active");
            li.classList.add("is-active");
        });
    });
};